module.exports = __webpack_public_path__ + "static/media/bell-ballon.6e036fc5.svg";